import { Microservice } from '../api/microservice.interfaces';
import { HttpUrl } from './http';

/** An environment name (e.g. "qa8" ) and value (e.g. "qa8" or "ode.msvc") pair. */
export interface Environment {
  /** Environment name (e.g. "qa8"). */
  name: string;

  /** Environment value (e.g. "qa8"). */
  value: string;
}

export interface EnvironmentUrls {
  /** Hosted content URL. */
  hostedContentUrl: string;

  /** Metadata URL. */
  metadata: string;

  /** Microservices URLs. */
  microservices: Record<Microservice, HttpUrl> | {};

  /** Services URL. */
  services: string;
}

export interface Identifier {
  Type?: string;
  Value: string;
}

export interface InvAction<T> {
  payload: T;
}

/** The shells that can serve a module's UI. */
export const EntryShell = {
  Angular: 'angular',
  React: 'react'
} as const;

export type EntryShell = (typeof EntryShell)[keyof typeof EntryShell];

export interface InvApplication {
  angularBasePath?: string;
  authorizeFn?: Function;
  basePath: string;
  cssName?: string;
  /**
   * Shell users land in when they enter the module, i.e. the destination of the
   * app switcher and of the default post-authentication redirect. Defaults to
   * React; set it to Angular for a module whose React shell is not yet the
   * experience users should land on. Deep links keep resolving against
   * `basePath` either way.
   */
  defaultEntryShell?: EntryShell;
  enableHomeLink?: boolean;
  glyph: string;
  isActive: boolean;
  isDeployed: boolean;
  isStandalone: boolean;
  name: string;
  order: number;
  preferenceKey: string;
  securityAttributeId: number;
  sRef?: string;
  version?: string;
}

export interface LabelValuePair<ValueType = any> {
  label: string;
  value: ValueType;
}

export interface KeyValuePair<KeyType, ValueType = string> {
  Key: KeyType;
  Value: ValueType;
}

// TODO: refacetor this to be Value as same type os T[K]
// ie fix this const test: KeyValueOf<{ a: string; b: number }> = { Key: 'a', Value: 1 };
export type KeyValueOf<T, K extends keyof T = keyof T> = {
  Key: K;
  Value: T[K];
};

export type Optional<T, K extends keyof T> = Omit<T, K> & Partial<T>;
